import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { getCurrentInstance, ref, onMounted, onUnmounted } from "vue";
import { Subscription } from "rxjs";
import { ApiError, EVENT_TOPIC_API_ERROR } from "@velites/api";


const __default__ = {
  name: "GlobalDialog",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { proxy } = getCurrentInstance() as any;
let showLogin = ref<boolean>(false);

// api_error_dialog相关
let apiErrorSubscription = ref<Subscription>();
let showError = ref<boolean>(false); // 全局错误弹层是否启动
let errorDesc = ref<string>(""); // 全局错误文本描述
const apiErrorSub = () => {
  // 订阅api_error
  apiErrorSubscription.value = proxy.$event.subscribeEvent(
    [EVENT_TOPIC_API_ERROR],
    (res: any) => {
      if (!res.data.options.suppressIndicator) {
        let err: ApiError = res.data.error;
        switch (err.httpStatus) {
          case 401:
            showLogin.value = true;
            break;
          case 403:
            showError.value = true;
            errorDesc.value = "用户没有权限";
            break;
          case 500:
            showError.value = true;
            errorDesc.value = "网络异常，请刷新页面";
            break;
          default:
            showError.value = true;
            if (err?.business) {
              errorDesc.value = err.message || "";
            } else {
              // 超时 err.httpStatus：undefined
              if (err?.extra?.code === "ECONNABORTED") {
                errorDesc.value = "链接超时，请刷新页面";
                return;
              }
              // 断网 err.httpStatus：undefined
              if (err.message === "Network Error") {
                errorDesc.value = "网络错误";
                return;
              }
              errorDesc.value = "未知错误";
            }
            break;
        }
      }
    }
  );
};

// 全屏加载组件相关
const EVENT_FULL_SCREEN_LOADING = "event.full.screen.loading.text";
let fullScreenLoadingText = ref<string>("");
let fullScreenLoadingSubscription = ref<Subscription>();
const fullScreenLoadingSub = () => {
  fullScreenLoadingSubscription.value = proxy.$event.subscribeEvent(
    [EVENT_FULL_SCREEN_LOADING],
    (res: any) => {
      fullScreenLoadingText.value = res.data;
    }
  );
};

onMounted(() => {
  apiErrorSub();
  fullScreenLoadingSub();
});

onUnmounted(() => {
  apiErrorSubscription?.value?.unsubscribe();
  fullScreenLoadingSubscription?.value?.unsubscribe();
});

return (_ctx: any,_cache: any) => {
  const _component_global_full_screen_loading = _resolveComponent("global-full-screen-loading")!
  const _component_global_network_error_dialog = _resolveComponent("global-network-error-dialog")!
  const _component_global_login_dialog = _resolveComponent("global-login-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_global_full_screen_loading, {
      text: _unref(fullScreenLoadingText),
      "onUpdate:text": _cache[0] || (_cache[0] = ($event: any) => (_isRef(fullScreenLoadingText) ? (fullScreenLoadingText).value = $event : fullScreenLoadingText = $event))
    }, null, 8, ["text"]),
    _createVNode(_component_global_network_error_dialog, {
      showError: _unref(showError),
      "onUpdate:showError": _cache[1] || (_cache[1] = ($event: any) => (_isRef(showError) ? (showError).value = $event : showError = $event)),
      errorDesc: _unref(errorDesc)
    }, null, 8, ["showError", "errorDesc"]),
    _createVNode(_component_global_login_dialog, {
      showLogin: _unref(showLogin),
      "onUpdate:showLogin": _cache[2] || (_cache[2] = ($event: any) => (_isRef(showLogin) ? (showLogin).value = $event : showLogin = $event))
    }, null, 8, ["showLogin"])
  ], 64))
}
}

})